import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { Toaster } from '../components/ui/toaster';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      toast({
        title: "Message Sent!",
        description: "We'll get back to you within 24 hours.",
      });
      setFormData({ name: '', email: '', phone: '', message: '' });
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-light text-gray-800 mb-4">Contact Us</h1>
          <p className="text-lg text-gray-600">
            We'd love to hear from you. Schedule an appointment or send us a message.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div>
            <h2 className="text-2xl font-light mb-8 text-gray-800">Get In Touch</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin size={24} className="text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium text-gray-800 mb-1">Visit Our Studio</h3>
                  <p className="text-gray-600">2945 Walnut Hill Ln.<br />Dallas, Texas 75229</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone size={24} className="text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium text-gray-800 mb-1">Call Us</h3>
                  <a href="tel:214-952-0001" className="text-gray-600 hover:text-gray-900">214-952-0001</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Mail size={24} className="text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium text-gray-800 mb-1">Email Us</h3>
                  <a href="mailto:dqkyukim@gmail.com" className="text-gray-600 hover:text-gray-900">dqkyukim@gmail.com</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock size={24} className="text-gray-700 mt-1" />
                <div>
                  <h3 className="font-medium text-gray-800 mb-1">Hours</h3>
                  <p className="text-gray-600">
                    Mon-Fri: 10:00 AM - 7:00 PM<br />
                    Sat: 10:00 AM - 6:00 PM<br />
                    Sun: Closed
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div>
            <h2 className="text-2xl font-light mb-8 text-gray-800">Send a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <Input
                  type="text"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  required
                />
              </div>
              <div>
                <Input
                  type="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  required
                />
              </div>
              <div>
                <Input
                  type="tel"
                  placeholder="Your Phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                />
              </div>
              <div>
                <Textarea
                  placeholder="Your Message"
                  rows={6}
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  required
                />
              </div>
              <Button 
                type="submit" 
                className="w-full bg-gray-900 hover:bg-gray-800"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Message'}
              </Button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
      <Toaster />
    </div>
  );
};

export default Contact;